import { QuoteLineItem } from '@css-xp/graphtypes/src/generated-types-sxp';
import { QuoteContractType } from '@css-xp/ppc-types';
import { Maybe, generatedTypesSxp } from '@css-xp/graphtypes';

export const isExternallyBilled = (quoteLineItems?: QuoteLineItem[]): boolean => {
  if (!quoteLineItems || quoteLineItems.length === 0) {
    return false;
  }

  return quoteLineItems.some((quoteLineItem) => {
    const offerings = quoteLineItem?.offerings;

    if (!Array.isArray(offerings)) {
      return false;
    }

    return offerings[0]?.pricingType === 'EXTERNAL';
  });
};

export const areAllLineItemsExternallyBilled = (quoteLineItems?: QuoteLineItem[]): boolean => {
  if (!quoteLineItems || quoteLineItems.length === 0) {
    return false;
  }

  return quoteLineItems.every((quoteLineItem) => {
    const offerings = quoteLineItem?.offerings;

    if (!Array.isArray(offerings)) {
      return false;
    }

    return offerings[0]?.pricingType === 'EXTERNAL';
  });
};

export const getReadableContractType = (contractType: QuoteContractType): string | null => {
  switch (contractType) {
    case null:
    case undefined:
      return 'Standard Atlassian Customer Agreement';
    case QuoteContractType.STANDARD_ACA:
      return 'Standard Atlassian Customer Agreement';
    case QuoteContractType.ELA_CONTRACT:
      return 'Enterprise Licensing Agreement';
    case QuoteContractType.NEGOTIATED_ACA:
      return 'Negotiated Atlassian Customer Agreement';
    default:
      // If nothing matches, we will return null so that we can show '-' in the UI
      return null;
  }
};

export const shouldShowQuoteDownloadOptions = (status?: Maybe<generatedTypesSxp.QuoteStatus> | undefined): boolean => {
  if (!status) {
    return false;
  }

  return status !== generatedTypesSxp.QuoteStatus.STALE && status !== generatedTypesSxp.QuoteStatus.CANCELLED;
};
